import { forwardRef } from "react";

import Icon from "@/components/Icon";
import AiLunaTagFullSVG from "./ai-luna-tag-full.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const AiLunaTagFullIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return (
    <Icon
      title="Luna tag with sparkle"
      ref={ref}
      SvgComponent={AiLunaTagFullSVG}
      {...props}
    />
  );
});

export default AiLunaTagFullIcon;
